import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class IncomingInvoiceService {
static incomingInvoiceCreate = async (bodyFormData) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/incoming-invoice/create",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static incomingInvoiceDetailsSearch = async (productId, searchTerm, rowsPerPage, page) => {
    try {
      let filter = [];

      if(searchTerm){
        filter.push({'keyword': searchTerm})
      }

      if(productId){
        filter.push({'productId': productId})
      }
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/incoming-invoice/search",
        data: {
          filter: filter,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let incomingInvoiceDetail = response.data.data;
      return incomingInvoiceDetail;
    } catch (err) {
      throw err;
    }
  };

  static incomingInvoiceDetailsID = async (incomingInvoiceID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/incoming-invoice/" + incomingInvoiceID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let incomingInvoiceDetailID = response.data.data;

      return incomingInvoiceDetailID;
    } catch (err) {
      throw err;
    }
  };

  static incomingInvoiceAllDetails = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/incoming-invoice/get/all",
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let incomingInvoiceDetail = response.data.data;

      return incomingInvoiceDetail;
    } catch (err) {
      throw err;
    }
  };

  static incomingInvoiceDelete = async (incomingInvoiceID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/incoming-invoice/delete/" + incomingInvoiceID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static incomingInvoiceUpdate = async (incomingInvoiceID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/incoming-invoice/update/" + incomingInvoiceID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static incomingInvoiceItemDelete = async (incomingInvoiceItemID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/incoming-invoice/delete/invoice-item/" + incomingInvoiceItemID,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

}
